import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Container from "../../../../base/components/container.js"
import IFrame from "../../../../base/components/iframe.js";

import { ProjectModel } from "../../../../models/projects/project_model.js";

const blockStyles = makeStyles(theme => ({
  container: {
    ['@media (max-width: 768px)']: {
      paddingLeft: "24px",
      paddingRight: "24px"
    },
  },
  title: {
    marginBottom: "24px !important",
    ['@media (max-width: 768px)']: {
      marginBottom: "12px !important"
    },
  },
  text: {
    display: "block",
    "& + &": {
      marginTop: "16px",
      ['@media (max-width: 768px)']: {
        marginTop: "4px",
      },
    }
  },
  map: {
    marginTop: "30px",
    width: "100%",
    height: "320px",
  }
}));

const AddressBlock =  (props) => {

  const classes = blockStyles();
  const { className, project } = props;

  const address = project.address;
  if(!address) {
    return <React.Fragment />
  }

  const { street, number } = address;
  const { postalCode, city } = address;
  
  const location = address.location || {};
  const { latitude, longitude } = location;

  const zoomLevel = 17;
  const url = `https://www.google.com/maps/embed/v1/place?key=${window.FIREBASE_API_KEY}&q=${latitude},${longitude}&zoom=${zoomLevel}`

  if (!(street || number || postalCode || city || latitude || longitude)) {
    return <React.Fragment />;
  }

  return (
    <div className = { className } >
      <Container className = { classes.container } >
        <h3 className = { classes.title } >
          { ProjectModel.fieldDisplayName("address") }
        </h3>
        {
          street && number &&
          <span className = { classes.text } >
            { `${street} ${number}` }
          </span>
        }
        {
          postalCode && city &&
          <span className = { classes.text } >
            { `${postalCode} ${city}` }
          </span>
        }
      </Container>
      {
        latitude && longitude &&
        <div className = { classes.map } >
          <IFrame width = { "100%" }
                  height = { "320px" }
                  src= { url } />
        </div>
      }
      
    </div>
    
  );
}

export default AddressBlock;